/**
 * Builds a Google Maps URL from geographic coordinates.
 * Input validation is caller's responsibility.
 */
export function buildExternalMapUrl(latitude: number, longitude: number): string {
  return `https://www.google.com/maps?q=${latitude},${longitude}`;
}
